/**
 * 打开新任务服务
 */
export interface OpenNewTask {
    /**
     * 打开新任务
     * @param name
     * @param taskId
     */
    open(name: string, taskId?: string): void;
}

export const OpenNewTask = Symbol('OpenNewTask');
